import type { ThemeSwitcherTheme } from '@/interfaces/nav'

export function useThemeConfig() {
  const themes: ThemeSwitcherTheme[] = [
    {
      name: 'light',
      icon: 'mdi-weather-sunny',
    },
    {
      name: 'dark',
      icon: 'mdi-weather-night',
    },
  ]

  const systemPreferenceIsDark = window.matchMedia('(prefers-color-scheme: dark)').matches
  const defaultTheme = ref(localStorage.getItem('myhq-v3-theme') ?? (systemPreferenceIsDark ? 'dark' : 'light'))

  const currentTheme = computed({
    get() {
      return defaultTheme.value
    },
    set(value: string) {
      defaultTheme.value = value
      localStorage.setItem('myhq-v3-theme', value)
    },
  })

  const getNextThemeName = () => {
    return currentTheme.value === themes[0].name ? themes[1].name : themes[0].name
  }

  const getNextThemeIcon = () => {
    return currentTheme.value === themes[0].name ? themes[1].icon : themes[0].icon
  }

  return {
    themes,
    currentTheme,
    getNextThemeName,
    getNextThemeIcon,
    defaultTheme,
  }
}
